
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/themes/[themeSlug]",
      function () {
        return require("private-next-pages/themes/[themeSlug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/themes/[themeSlug]"])
      });
    }
  